import { environment } from 'src/environments/environment';

export class AppUrl {
    //Systeam Configuration
    // static readonly BASE_URL = "http://localhost:8080/endlos-api";
    static readonly BASE_URL = "https://bharat.endlos.in/endlos-api";

 // Error pages Url Start
    static readonly ERROR = 'error';
    static readonly INTERNAL_SERVER_ERROR = 'internal-server-error';
    static readonly PAGE_NOT_FOUND = 'page-not-found';
    static readonly SERVICE_UNAVAILABLE = 'service-unavailable';
    static readonly UNAUTHORIZED = 'unauthorized';
    static readonly FORBIDDEN = 'forbidden';
    static readonly BAD_GATEWAY = 'bad-gateway';
    static readonly BAD_REQUEST = 'bad-request';

    //Module Operations Start
    static readonly VIEW_OPERATION = 'view/';
    static readonly LIST_OPERATION = 'list';
    static readonly EDIT_OPERATION = 'edit/';
    static readonly ADD_OPERATION = 'add';

    // API CURD operation URLs
    static readonly API_ADD = '/add';
    static readonly API_VIEW = '/view';
    static readonly API_EDIT = '/edit';
    static readonly API_UPDATE = '/update';
    static readonly API_DELETE = '/delete';
    static readonly API_SEARCH = '/search'


    //Module Pages Start
    static readonly HOME = '';
    static readonly DASHBOARD = 'dashboard';
    static readonly HEARTBEAT = 'heartbeat';
    static readonly ERROR_ALARM = 'error-alarm';
    static readonly TRANSACTION = 'transaction';
    static readonly SYSTEM_SPECIFICATION = 'system-specification';
    static readonly MACHINE = 'machine';


}

export class ApiUrlParameter {

    // API URL PARAMETER
    static readonly ID_URL = 'id=';
    static readonly START_URL = 'start=';
    static readonly RECORD_SIZE_URL = 'recordSize=';
    static readonly ORDER_TYPE_URL = 'orderType=';
    static readonly ORDER_PARAM_URL = 'orderParam=';
    static readonly REQUIRED_COMPRESS_IMAGE = "requireCompressImage=";
    static readonly FILE_ID = "fileId=";
    static readonly ENDLOS_API = "endlos"
    static readonly APPROVE = "approve=";
    static readonly MACHINE_ID = "machineId=";
    static readonly ALL_MACHINES = "all-machines="

}

export class Apiurl {
    static readonly PRIVATE_URL = '/private';
    static readonly PUBLIC_URL = '/public';
    static readonly SYSTEM_SPECIFICATION_URL = '/system-specification';
    static readonly HEARTBEAT_URL = '/heartbeat';
    static readonly ERROR_ALARM_URL = '/error-alarm';
    static readonly TRANSACTION_URL = '/transaction';
    static readonly PRIVATE_DASHBOARD_URL = Apiurl.PRIVATE_URL + '/dashboard';
    static readonly SAVE = '/save';
    static readonly SEARCH = '/search';
    static readonly MACHINE_URL = '/machine';
}